import {IMapPopupProperties} from '../../core/interfaces/models'
import Axios from 'axios'
import appConfig from '../../reducers/appConfig'

import * as React from 'react'
import {connect} from 'react-redux'
import {getFeatureTitle} from '../../core/helpers'
import {
  IDataQueriesDispatcher,
  IFeatureTablesDispatcher,
  IMapDispatcher,
  IPopupDispatcher,
  ISidebarDispatcher,
  ISingleViewDispatcher
} from '../../core/interfaces/dispatchers'
import {ControlType, IFeatureLayerInfos, QueryTarget} from '../../core/interfaces/reducers'
import {Feature} from '../../core/models'
import {appDataQueriesDispatcher} from '../../dispatchers/appDataQueriesDispatcher'
import {appFeatureTablesDispatcher} from '../../dispatchers/appFeatureTablesDispatcher'
import {appMapDispatcher} from '../../dispatchers/appMapDispatcher'
import {appPopupDispatcher} from '../../dispatchers/appPopupDispatcher'
import {appSidebarDispatcher} from '../../dispatchers/appSidebarDispatcher'
import {appSingleViewDispatcher} from '../../dispatchers/appSingleViewDispatcher'
import {IAppStore} from '../../interfaces/reducers'

interface DispatchProps
  extends
    IMapDispatcher,
    IFeatureTablesDispatcher,
    IPopupDispatcher,
    ISingleViewDispatcher,
    IDataQueriesDispatcher,
    ISidebarDispatcher {}

interface ParentProps {
  hideTable?: boolean
}

interface OwnProps {
  layerInfos: IFeatureLayerInfos
  popup: IMapPopupProperties
}

type Props = DispatchProps & OwnProps & ParentProps

const AppPopupHeaderClass = (props: Props) => {
  const getSelector = (
    data: {
      id: string
      feature: Feature
    }[]
  ) => {
    const options: JSX.Element[] = []
    data.forEach((d, i) => {
      const title = getFeatureTitle(d.feature, props.layerInfos[d.id]).toUpperCase()
      options.push(
        <option key={i} value={i}>
          {title}
        </option>
      )
    })
    return (
      <select
        className="app-popup-header-selector form-control"
        value={props.popup.selectedPage}
        onChange={e =>
          props.setPopupProperties({
            ...props.popup,
            selectedPage: parseInt(e.target.value)
          })
        }
      >
        {options}
      </select>
    )
  }
  const getTitle = (
    data: {
      id: string
      feature: Feature
    }[]
  ) => {
    if (props.popup.data && props.popup.data.length > 1) {
      return getSelector(props.popup.data)
    }
    return (
      <span className="app-popup-header-title">
        {getFeatureTitle(
          data[props.popup.selectedPage].feature,
          props.layerInfos[data[props.popup.selectedPage].id]
        ).toUpperCase()}
      </span>
    )
  }
  const getExportAsDxf = (
    data: {
      id: string
      feature: Feature
    }[]
  ) => {
    if (props.layerInfos[data[props.popup.selectedPage].id].sourceDescription.layerName == 'Parcel') {
      return (
        <div
          style={{color: 'rgb(13, 48, 88)', cursor: 'pointer', fontSize: '35px'}}
          onClick={() => {
            Axios.post(appConfig.urls.xyApiUrl + '/ExportParcel', {
              ParcelId: (data[props.popup.selectedPage].feature as any).values_['Id']
            })
              .then(r => {
                props.setSelectedFeature(feat, id)
                props.setQueries(id, {
                  Id: {
                    controlType: ControlType.NumberInput,
                    controlValue: featId,
                    queryTarget: QueryTarget.Data,
                    where: `"${info.sourceDescription.idField}" = ${featId}`
                  }
                })
                props.setTablesVisibility({[id]: {}})
                props.refrashTable(id)
                props.setSelected('registers')
                props.setMinimized(false)
              })
              .catch(function (error) {
                console.log(error)
              })
          }}
        >
          <i className="fa fa-layer-group" title="DXF Export" />
        </div>
      )
    } else if (props.layerInfos[data[props.popup.selectedPage].id].sourceDescription.layerName == 'Quarter') {
      return (
        <div
          style={{color: 'rgb(13, 48, 88)', cursor: 'pointer', fontSize: '35px'}}
          onClick={() => {
            Axios.post(appConfig.urls.xyApiUrl + '/ExportQuarter', {
              QuarterId: (data[props.popup.selectedPage].feature as any).values_['Id']
            })
              .then(r => {
                props.setSelectedFeature(feat, id)
                props.setQueries(id, {
                  Id: {
                    controlType: ControlType.NumberInput,
                    controlValue: featId,
                    queryTarget: QueryTarget.Data,
                    where: `"${info.sourceDescription.idField}" = ${featId}`
                  }
                })
                props.setTablesVisibility({[id]: {}})
                props.refrashTable(id)
                props.setSelected('registers')
                props.setMinimized(false)
              })
              .catch(function (error) {
                console.log(error)
              })
          }}
        >
          <i className="fa fa-layer-group" title="DXF Export" />
        </div>
      )
    } else {
      return null
    }
  }

  const getExportParcelAsCAD4 = (
    data: {
      id: string
      feature: Feature
    }[]
  ) => {
    if (props.layerInfos[data[props.popup.selectedPage].id].sourceDescription.layerName == 'Parcel') {
      return (
        <div
          style={{color: 'rgb(13, 48, 88)', cursor: 'pointer', fontSize: '35px'}}
          onClick={() => {
            Axios.get(
              appConfig.urls.xyApiUrl +
                '/cad-export?parcelId=' +
                (data[props.popup.selectedPage].feature as any).values_['Id']
            )
              .then(r => {
                props.setSelectedFeature(feat, id)
                props.setQueries(id, {
                  Id: {
                    controlType: ControlType.NumberInput,
                    controlValue: featId,
                    queryTarget: QueryTarget.Data,
                    where: `"${info.sourceDescription.idField}" = ${featId}`
                  }
                })
                props.setTablesVisibility({[id]: {}})
                props.refrashTable(id)
                props.setSelected('registers')
                props.setMinimized(false)
              })
              .catch(function (error) {
                console.log(error)
              })
          }}
        >
          <i className="fa fa-layer-group" title="CAD4 Export" />
        </div>
      )
    } else {
      return null
    }
  }

  if (!props.popup.data) {
    return null
  }
  const feat = props.popup.data![props.popup.selectedPage].feature
  const id = props.popup.data![props.popup.selectedPage].id
  const info = props.layerInfos[props.popup.data[props.popup.selectedPage].id]
  if (!info) return null
  const featId = feat.getProperties()[info.sourceDescription.idField]
  return (
    <div key="popup-header" className="app-popup-header">
      {getTitle(props.popup.data)}
      {props.hideTable || appConfig.isPublic ? null : getExportAsDxf(props.popup.data)}
      {props.hideTable || appConfig.isPublic ? null : getExportParcelAsCAD4(props.popup.data)}
      {props.hideTable || appConfig.isPublic ? null : (
        <div
          style={{color: 'rgb(13, 48, 88)', cursor: 'pointer', fontSize: '32px', margin: '0 3px'}}
          onClick={() => {
            props.setSelectedFeature(feat, id)
            props.setQueries(id, {
              Id: {
                controlType: ControlType.NumberInput,
                controlValue: featId,
                queryTarget: QueryTarget.Data,
                where: `"${info.sourceDescription.idField}" = ${featId}`
              }
            })
            props.setTablesVisibility({[id]: {}})
            props.refrashTable(id)
            props.setSelected('registers')
            props.setMinimized(false)
          }}
        >
          <i className="fas fa-table" title="Детаили" />
        </div>
      )}
      <div
        style={{color: 'rgb(13, 48, 88)', cursor: 'pointer', fontSize: '35px'}}
        onClick={() => {
          props.setPopupProperties({
            ...props.popup,
            show: false,
            data: []
          })
        }}
      >
        <i className="fas fa-times" />
      </div>
    </div>
  )
}

const mapStateToProps = (state: IAppStore) => {
  return {
    popup: state.map.popup,
    layerInfos: state.layerInfos.featureLayerInfos
  }
}

export const AppPopupHeader = connect<OwnProps, DispatchProps, ParentProps>(mapStateToProps, {
  ...appFeatureTablesDispatcher,
  ...appDataQueriesDispatcher,
  ...appSingleViewDispatcher,
  ...appPopupDispatcher,
  ...appMapDispatcher,
  ...appSidebarDispatcher
})(AppPopupHeaderClass)
